/**
 * A path, a guard, and a screen imported from a page slice.
 *
 * The guard asks the feature one question — where does the current session belong? — so this route
 * cannot disagree with any other about the answer. Notably it sends a *degraded* session into the app
 * rather than keeping it here: a session that is merely failing is still a session, and asking it to
 * sign in again would be the forced-logout bug wearing a router costume.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionRedirectFrom } from '~/entities/session';
import { SignInScreen } from '~/pages/sign-in';

export const Route = createFileRoute('/sign-in')({
  beforeLoad: () => {
    const destination = sessionRedirectFrom('/sign-in');
    // `throw: true` makes `redirect` raise the router's own Response itself. A bare `throw
    // redirect(...)` throws a non-Error, which is exactly what `only-throw-error` is there to catch.
    if (destination !== null) redirect({ to: destination, replace: true, throw: true });
  },
  component: SignInScreen,
});
